window.app = window.app || {};

window.app.technicalPages = {
  el: {
    body: document.querySelector('body'),
    content: document.querySelector('.mt-technical-pages__content-text, .mt-technical-pages__left')
  },

  init: function() {
    const _this = this;
    if (!_this.el.content) return;

    // App technical pages
    if (_this.el.body.getAttribute('page') === 'mt-technical-pages-app') {
        const allowedLinks = ['/pages/privacy-policy', '/pages/cookie-policy', '/pages/warranty', '/pages/terms-of-use', '/pages/us-privacy-notice', '/pages/refund-policy', '/pages/dsr', 'mailto:'];
        _this.el.content.querySelectorAll('a').forEach(link => {
            if (allowedLinks.some(allowedLink => link.href.includes(allowedLink))) {
                link.classList.add('link-allowed');
                if (!link.href.includes('mailto:') && !link.href.includes('/pages/dsr')) {
                    link.href += '?view=mt-technical-pages-app';
                }
            } else {
                link.outerHTML = `<span>${link.innerHTML}</span>`;
            }
        });
    }    
  }
}
window.app.technicalPages.init();